import axios from 'axios';
import { API_URL } from '../config';
export async function getProductionPlan(params) {
  return (
    await axios.get(`${API_URL}/production-plan/current`, {
      params,
      withCredentials: true,
    })
  ).data;
}
export async function importProductionPlan(file) {
  const data = new FormData();
  data.append('file', file);
  return (
    await axios.post(`${API_URL}/production-plan/imports`, data, {
      withCredentials: true,
    })
  ).data;
}
